import { render, staticRenderFns } from "./PackagesTile.vue?vue&type=template&id=3a3287e0"
import script from "./PackagesTile.vue?vue&type=script&lang=ts"
export * from "./PackagesTile.vue?vue&type=script&lang=ts"
import style0 from "./PackagesTile.vue?vue&type=style&index=0&id=3a3287e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports